import { Injectable } from '@angular/core';
//import * as constants from '../configurations/constants'

@Injectable()
export class LocalStorageService {

    constructor() {
    }

    setItem(key, item) {
        localStorage.setItem(key, JSON.stringify(item));
    }

    getClient(item?: string) {
        let cliente = JSON.parse(localStorage.getItem('cliente'));
        return item ? cliente[item] : cliente;
    }

    get(key: string): any {
        return JSON.parse(localStorage.getItem(key));
    }

    getToken() {
        return JSON.parse(localStorage.getItem("TokenSecurity"));
    }
    setToken(token) {
        localStorage.setItem("TokenSecurity", token);
    }

    removeItem(key: string) {
        localStorage.removeItem(key)
    }

    removeAll() {
        localStorage.clear();
    }
}